<template>
  <div class="relative overflow-hidden">
    <img class="w-full object-cover md:h-96 h-60 brightness-50" src="@/assets/coding.jpg" alt="コーディング画像">
    <div class="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">
      <p class="md:text-sm text-xs tracking-widest mb-3 text-blue-300 font-medium">Software Development Partner / Improver LLC</p>
      <h1 class="md:text-5xl text-2xl font-bold leading-tight mb-4">
        AIと実装力で<br class="hidden md:block">
        プロダクト開発を加速する技術パートナー
      </h1>
      <p class="md:text-lg text-sm text-gray-300 mb-8">
        要件定義から設計・開発・リリースまで一気通貫で対応します。
      </p>
      <a
        href="#inquiry"
        class="bg-blue-500 hover:bg-blue-600 transition-colors text-white font-semibold md:text-base text-sm px-8 py-3 rounded-full shadow-lg"
      >
        無料で相談する →
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>
